import GameModel from '../../../vendor_core/core/src/model/GameModel';
import CascadeFillExplodedState from '../../../vendor_core/core/src/states/cascade/CascadeFillExplodedState';

export default class CCCascadeFillExplodedState extends CascadeFillExplodedState {
    protected delayToExit: number = 50;
    protected getExitDelay(): number {
        return GameModel.turboSpin ? this.delayToExit + 200 : this.delayToExit;
    }
}
